import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'pl', label: 'PL', flag: '🇵🇱' },
  { code: 'tr', label: 'TR', flag: '🇹🇷' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'ru', label: 'RU', flag: '🇷🇺' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current  = i18n.language?.slice(0, 2) || 'pl';

  return (
    <div className="flex items-center gap-1">
      {LANGUAGES.map(({ code, label, flag }) => {
        const isActive = current === code;
        return (
          <button
            key={code}
            id={`lang-btn-${code}`}
            onClick={() => i18n.changeLanguage(code)}
            aria-label={`Switch to ${label}`}
            className={`
              flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-semibold font-sans
              transition-all duration-200 ease-out
              ${isActive
                ? 'bg-bistro-gold text-bistro-dark shadow-gold'
                : 'text-bistro-muted hover:text-bistro-cream hover:bg-bistro-surface'
              }
            `}
          >
            <span className="text-sm leading-none">{flag}</span>
            <span className="hidden sm:inline">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
